<script setup lang="ts">
import { VSkeletonLoader } from 'vuetify/components';

type PropsType = {
    type: VSkeletonLoader['$props']['type'];
    loading?: boolean;
    height?: string | number;
    width?: string | number;
    maxHeight?: string | number;
    maxWidth?: string | number;
    minHeight?: string | number;
    minWidth?: string | number;
    boilerplate?: boolean;
    color?: string;
    elevation?: string | number;
    rounded?: boolean | string | number;
};

withDefaults(defineProps<PropsType>(), {
    loading: true,
    color: 'grey-100',
});

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VSkeletonLoader
        v-if="loading"
        :type="type"
        :height="height"
        :width="width"
        :max-height="maxHeight"
        :max-width="maxWidth"
        :min-height="minHeight"
        :min-width="minWidth"
        :boilerplate="boilerplate"
        :color="color"
        :elevation="elevation"
        :rounded="rounded"
        v-bind="$attrs"
        class="b-skeleton-loader"
    />
    <div v-else>
        <slot />
    </div>
</template>
